import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navigation } from "@/components/Navigation";
import { ScrollProgress } from "@/components/ScrollProgress";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CareerPage from "@/pages/CareerPage";
import VenturesPage from "@/pages/VenturesPage";
import BooksPage from "@/pages/BooksPage";
import IdeasPage from "@/pages/IdeasPage";
import InsightsPage from "@/pages/InsightsPage";
import InsightArticlePage from "@/pages/InsightArticlePage";
import SpeakingPage from "@/pages/SpeakingPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ContactPage from "@/pages/ContactPage";
import SchedulePage from "@/pages/SchedulePage";
import CareerHistoryPage from "@/pages/CareerHistoryPage";
import AIWhispererPage from "@/pages/AIWhispererPage";
import SpeakingBackupPage from "@/pages/SpeakingBackupPage";
import HCAPage from "@/pages/HCAPage";
import ChefBBPage from "@/pages/ChefBBPage";
import NotFoundPage from "@/pages/NotFoundPage";

function AppLayout() {
  const location = useLocation();
  const isHCA = location.pathname.startsWith('/hca');

  return (
    <>
      <ScrollToTop />
      {!isHCA && <ScrollProgress />}
      {!isHCA && <Navigation />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<Navigate to="/schedule" replace />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="/career-history" element={<CareerHistoryPage />} />
        <Route path="/ventures" element={<VenturesPage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/ideas" element={<IdeasPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/insights/:slug" element={<InsightArticlePage />} />
        <Route path="/speaking" element={<SpeakingPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/ai-whisperer" element={<AIWhispererPage />} />
        <Route path="/speaking-backup" element={<SpeakingBackupPage />} />
        <Route path="/hca" element={<HCAPage />} />
        <Route path="/chefbb" element={<ChefBBPage />} />
        <Route path="/ChefBB" element={<ChefBBPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!isHCA && <Footer />}
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
